module.exports = __webpack_public_path__ + "img/circle-dollar-to-slot.1e601643.svg";